import { Notification } from "@/types/notification"
import { PublicUser } from "@/types/user"

import { BotAvatar } from "@/components/ui/avatar"
import { UserAvatar } from "@/components/user-avatar"

export type NotificationLeadingUser = PublicUser | "current" | undefined

export function getNotificationLeadingUser(
  notification: Notification
): NotificationLeadingUser {
  switch (notification.type) {
    case "comment":
    case "comment_mention":
    case "collaborator_joined":
    case "collection_collaborator_joined":
    case "collection_place_added":
    case "collection_note_added":
    case "collection_visibility_toggled":
      return notification.acting_user
    case "mention":
      return notification.message_type === "customer"
        ? notification.acting_user
        : undefined
    case "group_chat_message":
      return notification.message_type === "customer"
        ? notification.acting_user
        : undefined
    case "new_collaboration":
    case "new_collection_collaboration":
      return "current"
    case "new_follower":
      return notification.follower
    case "inspiration_published":
      return notification.creator
    case "inspiration_saved":
      return notification.saver
    case "collection_invitation":
      return notification.inviter
    default:
      return undefined
  }
}

export function NotificationAvatar({
  user,
}: {
  user?: NotificationLeadingUser
}) {
  return user ? (
    <UserAvatar size="xs" user={user !== "current" ? user : undefined} />
  ) : (
    <BotAvatar size="xs" />
  )
}

export function NotificationToastLeading({ value }: { value: Notification }) {
  return <NotificationAvatar user={getNotificationLeadingUser(value)} />
}
